/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {SensorBomTable} from "../BillOfMaterialsSection/BillOfMaterialsSection";


/**
 * Selected Sensors Table displays the current sensor configuration that is used
 * to generate green lines. You can also select sensors to modify green lines.
 */
export const SelectedSensorsTable = () => {
  return (
    <>
      <SensorBomTable filterAnalysis={true}/>
    </>
  )
}
